export default "__VITE_ASSET__LF9Io_Lc__"